import styled from 'styled-components'
import { media } from '../../layouts/utils'
import {
  borderRadius,
  colorBrandPrimary,
  colorNeutral,
  colorNeutralDark,
  fontFamily,
  shadow,
} from '../../global.style'

const blur = `
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(10px);
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const ContainerCard = styled.div`
  width: 32%;
  flex-direction: column;
  background-color: ${colorNeutral.light};
  border-radius: ${borderRadius.md};
  box-sizing: border-box;
  box-shadow: ${(props) => (props.usarBorda ? shadow.level1 : `none`)};
  display: flex;

  &:hover {
    box-shadow: ${(props) => (props.usarBorda ? shadow.level2 : `none`)};
  }

  ${media.phone`
        width: calc(100vw / 2);
        padding-right: 16px;

        & > span:nth-child(n+1) {
          display: flex;
          align-items: flex-end;
        }

        &:last-child {
            margin: 0;
        }
    `}
`

export const ContainerImagem = styled.img`
  width: 100%;
  border-radius: 8px;

  ${media.desktop`        
        min-height: 46px;
    `}
`
export const ContainerCTA = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.blur && blur}
  & button {
    padding: 0 10px;
    min-width: 150px;
  }

  ${media.desktop`
    flex-direction: column;
    & button {
      min-width: 100%;
    }
  `}

  ${media.large`
        & button {
            font-size:80%;
            transform: scale(0.95)
        }
    `}
`
export const ContainerText = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 5%;
  align-items: ${(props) =>
    props.alinhamento === 'Início'
      ? `start`
      : props.alinhamento === 'Fim'
      ? `end`
      : `center`};

  ${media.desktop`

        padding: 0;
    `}

`


export const ContainerItem = styled.div`
  min-height: ${(props) => props.size || '70px'};
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: inherit;
  width: 100%;
  justify-content: center;
  padding: 0px;

  ${media.desktop`
    align-items: center;
  `}

  ${media.phone`
    align-items: center;
    min-height: ${(props) => props.size || '85px'};
  `}
`

export const TituloCard = styled.span`
  color: ${colorBrandPrimary.marine};
  font-family: ${fontFamily.brand};
  font-size: 24px;
  letter-spacing: 0;
  line-height: 1.5rem;
  margin-bottom: 16px;
  min-height: 3rem;

  ${media.desktop`
        font-size: 20px;
    `}

  ${media.large`
        font-size: 16px;
        margin-bottom: 8px;
  `}
`
export const TituloItem = styled.div`
  color: ${colorBrandPrimary.marine};
  font-family: ${fontFamily.brand};
  font-size: 20px;
  letter-spacing: 0;
  line-height: 48px;
  ${props => props.blur && blur}

  ${media.desktop`
        font-size: 16px;
        line-height: 20px;
        text-align: center;
    `}

`

export const DescricaoItem = styled.div`
  color: ${colorBrandPrimary.marine};
  font-family: ${fontFamily.neutral};
  font-size: ${(props) => props.subtitle ? '12px' : '16px'};
  letter-spacing: 0;
  text-align: center;

  ${media.phone`
        font-size: ${(props) => props.subtitle ? '10px' : '14px'};
        line-height: 21px;
        text-align: center;
        max-width: 149px;
    `}
`
export const ObservacaoItem = styled.div`
  color: ${colorNeutralDark['80']};
  font-family: ${fontFamily.neutral};
  font-size: 12px;
  text-align: center;
  letter-spacing: 0;
  line-height: 1.3rem;
  width: ${(props) => (props.width ? props.width : '100%')};
  ${props => props.blur && blur}

  ${media.phone`
        width: 155px;
        margin-top: 4px;
    `}
`
export const Icones = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(props) =>
    props.alinhamento === 'Início'
      ? `start`
      : props.alinhamento === 'Fim'
      ? `end`
      : `center`};
  img {
    width: 36px;

    ${media.phone`
            width: 30px;
        `}
  }
  margin-right: 12px;

  ${media.phone`
        align-items: center;
    `}
`

export const TextoCard = styled.span`
  color: #110e49;
  font-family: ${fontFamily.neutral};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 100px;
  align-items: center;
  display: flex;
`

export const SpacerItem = styled.div`  
  margin-left: 12px;  
`

export const CardLink = styled.div`
  margin-top: 20px;
  ${(props) => props.blur && blur}
`

export const CheckboxContainer = styled.div`
  display: flex;
  font-size: 14px;
  color: ${colorBrandPrimary.marine};
  padding-bottom: 30px;
  ${(props) => props.blur && blur};
  .underline {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
`
